import Component from 'flarum/common/Component';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
// How near (pixels) the end of the list has to be for its next page.
const MARGIN = 600;

/**
 * Below a PagedList: its next page when the end of the list comes near the
 * screen - an infinite scroll - and a loading indicator while one is on its
 * way. An IntersectionObserver for the scrolling, and the same check after
 * every redraw: a list that doesn't fill the screen yet never moves in or
 * out of reach.
 */
export default class ListEnd extends Component {
  observer = null;
  oncreate(vnode) {
    super.oncreate(vnode);
    this.observer = new IntersectionObserver(() => this.check(), {
      rootMargin: `0px 0px ${MARGIN}px 0px`
    });
    this.observer.observe(this.element);
    this.check();
  }
  onupdate(vnode) {
    super.onupdate(vnode);
    this.check();
  }
  onremove(vnode) {
    super.onremove(vnode);
    this.observer?.disconnect();
  }
  check() {
    const list = this.attrs.list;
    if (list.loading || list.error || !list.hasMore) return;
    if (this.element.getBoundingClientRect().top - window.innerHeight < MARGIN) list.loadMore();
  }
  view() {
    return m("div", {
      className: "ChampisListEnd"
    }, this.attrs.list.loading && m(LoadingIndicator, null));
  }
}
flarum.reg.add('champis-exhibitions', 'forum/components/ListEnd', ListEnd);